<json-viewer [json]="logJson"></json-viewer>
